import type AutocompleteElement from '@github/auto-complete-element'
import {TemplateInstance} from '@github/template-parts'
// eslint-disable-next-line no-restricted-imports
import {on} from 'delegated-events'
import {onKey} from '../onfocus'

// Don't let users accidentally submit the form when you hit enter
onKey('keydown', '.js-security-manager-team-add-search', function (event: KeyboardEvent) {
  // TODO: Refactor to use data-hotkey
  /* eslint eslint-comments/no-use: off */
  /* eslint-disable no-restricted-syntax */
  if (event.key === 'Enter') {
    event.preventDefault()
  }
  /* eslint-enable no-restricted-syntax */
})

on('auto-complete-change', '.js-security-manager-team-add-auto-complete', function (event) {
  const autoComplete = event.target as AutocompleteElement
  if (!autoComplete.value) {
    return
  }

  const team_id = +autoComplete.value
  const team_name = autoComplete.querySelector<HTMLElement>(`[data-autocomplete-value='${team_id}']`)!.textContent!

  // clear the search box; if the user cancels the dialog they'll have to search again
  autoComplete.value = ''

  const template = document.querySelector<HTMLTemplateElement>('template.js-security-manager-team-add-confirm')!
  const instance = new TemplateInstance(template, {team_id, team_name})

  // have to capture the element _before_ adding it to the DOM
  const dialog = (instance.querySelector('details') as HTMLDetailsElement)!
  template.after(instance)

  // if the user cancels the dialog, remove it from the DOM
  dialog.addEventListener('details-dialog-close', () => {
    dialog.remove()
  })

  // hide but don't hide the <summary> element
  // normally this is used to trigger the dialog, but we're doing it here in script
  // <summary> has the modal backdrop/overlay, so we can't get rid of it
  dialog.querySelector('summary')!.style.fontSize = '0'

  dialog.open = true
})
